<div class="payer-installments-wrapper" [@fadeIn]>

  <!-- Header -->
  <div class="section-header">
    <div class="section-header-left">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256" fill="currentColor" class="section-icon">
        <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,56H216V96H40Z" opacity="0.3"/>
        <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V112H216Zm0-104H40V56H216Z"/>
        <path d="M80,144H48a8,8,0,0,0,0,16H80a8,8,0,0,0,0-16Zm0,24H48a8,8,0,0,0,0,16H80a8,8,0,0,0,0-16Z" opacity="0.5"/>
      </svg>
      <div>
        <h2 class="title-secondary">Minhas Parcelas</h2>
        <p class="title-secondary-description">Acompanhe e pague suas parcelas como responsável</p>
      </div>
    </div>
    <button mat-icon-button (click)="loadPayments()" [disabled]="isLoading()" matTooltip="Atualizar">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <mat-progress-bar *ngIf="isLoading()" mode="indeterminate" color="primary"></mat-progress-bar>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!isLoading() && payments().length === 0">
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 256 256" fill="currentColor" class="empty-icon">
      <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,56H216V96H40Z" opacity="0.3"/>
      <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V112H216Zm0-104H40V56H216Z"/>
    </svg>
    <p class="empty-title">Nenhum pagamento encontrado</p>
    <p class="empty-desc">Você ainda não possui pagamentos como responsável.</p>
  </div>

  <!-- Payments Accordion -->
  <div class="payments-list" [@listStagger]="payments().length" *ngIf="!isLoading() && payments().length > 0">
    <div class="card payment-accordion-card" *ngFor="let payment of payments()" [@fadeIn]>

      <!-- Payment Header (clicável) -->
      <div class="payment-accordion-header card-header" (click)="toggleInstallments(payment)">
        <div class="payment-header-main">
          <div class="payment-header-left">
            <div class="payment-meta">
              <span class="badge" [class]="getPaymentStatusClass(payment.status)">
                {{ getPaymentStatusLabel(payment.status) }}
              </span>
              <span class="payment-id">Pagamento #{{ payment.id }}</span>
            </div>
            <div class="payment-details-row">
              <span class="payment-method-badge">
                <mat-icon class="method-icon">{{ payment.method === 'PIX' ? 'qr_code_2' : payment.method === 'BOLETO' ? 'receipt' : 'credit_card' }}</mat-icon>
                {{ getPaymentMethodLabel(payment.method) }}
              </span>
              <span class="payment-installments-info">
                {{ payment.numberOfInstallments }}x de {{ formatCurrency((payment.totalAmount || 0) / (payment.numberOfInstallments || 1)) }}
              </span>
            </div>
          </div>
          <div class="payment-header-right">
            <span class="payment-total">{{ formatCurrency(payment.totalAmount) }}</span>
            <mat-icon class="expand-icon" [class.expanded]="payment.isExpanded">expand_more</mat-icon>
          </div>
        </div>
      </div>

      <!-- Installments Panel -->
      <div class="installments-panel" *ngIf="payment.isExpanded" [@expandCollapse]>

        <!-- Loading parcelas -->
        <div class="installments-loading" *ngIf="payment.isLoadingInstallments">
          <mat-spinner diameter="24"></mat-spinner>
          <span>Carregando parcelas...</span>
        </div>

        <!-- Lista de parcelas -->
        <div class="installments-table" *ngIf="!payment.isLoadingInstallments && payment.installments?.length">
          <div class="installment-row" *ngFor="let inst of payment.installments"
               [class.late]="inst.status === 'LATE'"
               [class.paid]="inst.status === 'PAID'">

            <div class="inst-col inst-num">
              <span class="inst-num-label">Parcela</span>
              <span class="inst-num-value">{{ inst.installmentNumber }}/{{ payment.numberOfInstallments }}</span>
            </div>

            <div class="inst-col inst-amount-col">
              <span class="inst-col-label">Valor</span>
              <span class="inst-amount-value">{{ formatCurrency(inst.amount) }}</span>
            </div>

            <div class="inst-col inst-due">
              <span class="inst-col-label">Vencimento</span>
              <span class="inst-due-value" [class.overdue]="inst.status === 'LATE'">
                {{ formatDate(inst.dueDate) }}
              </span>
            </div>

            <div class="inst-col inst-status-col">
              <span class="badge" [class]="getInstallmentStatusClass(inst.status)">
                {{ getInstallmentStatusLabel(inst.status) }}
              </span>
            </div>

            <div class="inst-col inst-action">
              <button
                *ngIf="canPayInstallment(inst)"
                mat-flat-button
                color="primary"
                class="btn-pay-inst"
                (click)="onPayInstallment(inst)"
                [disabled]="isProcessingInstallment(inst.id)">
                <mat-spinner *ngIf="isProcessingInstallment(inst.id)" diameter="16"></mat-spinner>
                <mat-icon *ngIf="!isProcessingInstallment(inst.id)">payments</mat-icon>
                {{ isProcessingInstallment(inst.id) ? 'Pagando...' : 'Pagar' }}
              </button>
            </div>

          </div>
        </div>

        <!-- Empty parcelas -->
        <div class="installments-empty" *ngIf="!payment.isLoadingInstallments && !payment.installments?.length">
          <mat-icon>receipt_long</mat-icon>
          <span>Nenhuma parcela encontrada para este pagamento.</span>
        </div>

      </div>

    </div>
  </div>

</div>
